/**
 * Utility functions for parsing and formatting labels
 */

/**
 * Parses text with % markers and converts them to HTML bold tags
 * Example: "Your items will be reserved until %5 PM on Tuesday, March 14%. If not picked up by this time, your order will be %canceled and payment refunded%."
 * Becomes: "Your items will be reserved until <b>5 PM on Tuesday, March 14</b>. If not picked up by this time, your order will be <b>canceled and payment refunded</b>."
 * 
 * @param text - Text containing % markers for bold content
 * @returns HTML string with <b> tags replacing % markers
 */
export const parseBoldMarkers = (text: string): string => {
    return text.replace(/%([^%]+)%/g, '<b>$1</b>');
};
